import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/LegalPage.css';
import SEOHelmet from '../components/SEOHelmet';

function DeleteAccount() {
  return (
    <div className="legal-page">
      <SEOHelmet
        title="Delete Account - Stratagease"
        description="How to delete your Marketing Strategy app account and request deletion of your personal data."
      />
      <div className="legal-container">
        <Link to="/" className="back-link">
          ← Back to Home
        </Link>

        <h1>Delete your account</h1>
        <p className="legal-intro">
          This page is for the Marketing Strategy app (com.app.stratagease).
        </p>
        <p className="legal-intro">
          You can delete your account in the app, or email us if you no longer
          have the app installed.
        </p>

        <div className="legal-content">
          <p className="legal-date">Last updated September 9, 2026</p>

          <h3>Delete in the Marketing Strategy app</h3>
          <ol>
            <li>Open Marketing Strategy and sign in.</li>
            <li>Go to More.</li>
            <li>Tap Delete Account and confirm.</li>
          </ol>
          <p>
            That removes your account on our servers. You will be signed out.
          </p>

          <h3>Request deletion by email</h3>
          <p>
            Email{' '}
            <a href="mailto:support@stratagease.com?subject=Delete%20Marketing%20Strategy%20account">
              support@stratagease.com
            </a>{' '}
            from the address you used to register. Put “Delete Marketing
            Strategy account” in the subject. Include the email on the account.
          </p>
          <p>
            We will delete the account and the personal data we hold for it
            within 30 days. You will get a confirmation email.
          </p>

          <h3>What we delete</h3>
          <ul>
            <li>Your profile and login</li>
            <li>Business details you entered in the app</li>
            <li>Files and chat content stored for that account</li>
          </ul>
          <p>
            We may keep records we are required to keep by law (for example
            payment records) for as long as those rules require.
          </p>
          <p>
            App Store and Google Play subscriptions are cancelled in your Apple
            or Google account, not on this page.
          </p>

          <h3>Questions</h3>
          <p>
            Email{' '}
            <a href="mailto:support@stratagease.com">support@stratagease.com</a>{' '}
            or{' '}
            <a href="mailto:mail@stratagease.com">mail@stratagease.com</a>.
          </p>
        </div>
      </div>
    </div>
  );
}

export default DeleteAccount;
